import * as angular from 'angular';
import * as _ from 'lodash';

import { IUserGroupsService } from '../../services';
import { UserGroups } from '@models/index';
import { Store } from '../Store';
import * as USERGROUPS from './userGroups.constants';

import {
    loadUserGroups,
    loadUserGroupsSuccess,
    deleteUserGroups,
    deleteUserGroupsSuccess,
    updateUserGroups,
    updateUserGroupsSuccess,
} from './userGroups.actions';

export interface IUserGroupActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<UserGroups[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<UserGroups[]>;
    updateOne(target: UserGroups): (dispatch: any, getState: () => Store) => angular.IPromise<UserGroups[]>;
    deleteOne(target: UserGroups): (dispatch: any, getState: () => Store) => angular.IPromise<UserGroups>;
}

export class UserGroupsActionsService implements IUserGroupActionsService {
    static serviceId = 'userGroupActionsService';
    static $inject = ['$q', 'userGroupsService'];

    constructor(
        private _$q: angular.IQService,
        private _userGroupsService: IUserGroupsService
    ) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { userGroups } = getState();
            if (!userGroups.isLoading && !userGroups.isLoaded) {
                dispatch(loadUserGroups());
                return this._userGroupsService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadUserGroupsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: USERGROUPS.USER_GROUPS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<UserGroups>(userGroups.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { userGroups } = getState();
            if (force || (!userGroups.isLoading && !userGroups.isLoaded)) {
                dispatch(loadUserGroups());
                return this._userGroupsService.getAll(force)
                    .then(data => {
                        dispatch(loadUserGroupsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: USERGROUPS.USER_GROUPS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<UserGroups>(userGroups.dictionary));
            }
        };
    }

    updateOne(target: UserGroups) {
        return (dispatch: any, getState: () => Store) => {
            const { userGroups } = getState();
            if (target) {
                dispatch(updateUserGroups(target));
                return this._userGroupsService.update(target)
                    .then(data => {
                        const result = data;
                        dispatch(updateUserGroupsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: USERGROUPS.USER_GROUPS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<UserGroups>(userGroups.dictionary));
            }
        };
    }

    deleteOne(target: UserGroups) {
        return (dispatch: any, getState: () => Store) => {
            const { userGroups } = getState();
                dispatch(deleteUserGroups(target.guid));
                return this._userGroupsService.deleteOne(target)
                    .then(data => {
                        const result = data;
                        dispatch(deleteUserGroupsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: USERGROUPS.USER_GROUPS_DELETE_ERROR, payload: reason });
                        throw reason;
                    });
        };
    }
}